import configure from 'redux-idle-monitor';
import {
    types
} from '../actions/types';
// import { idleStatusDelay, activeStatusAction, idleStatusAction } from '../actions/auth-actions';

import {
    logFirebaseError
} from './database/database-utils';
import {
    clearUserData,
    logOut
} from '../actions/auth-actions';
import {
    getClientData
} from '../actions/client-actions';

import firebase from '../firebase/firebase';
const db = firebase.database();

export const IDLESTATUS_AWAY = 'AWAY';
export const IDLESTATUS_INACTIVE = 'INACTIVE';
export const IDLESTATUS_EXPIRED = 'EXPIRED';

export const IDLE_STATUSES = [IDLESTATUS_AWAY, IDLESTATUS_INACTIVE, IDLESTATUS_EXPIRED];

// function getBaseURL() {
//     var url = location.href;  // entire url including querystring - also: window.location.href;
//     var baseURL = url.substring(0, url.indexOf('/', 14));

//     if (baseURL.indexOf('http://localhost') !== -1) {
//         // Base Url for localhost
//         var url = location.href;  // window.location.href;
//         var pathname = location.pathname;  // window.location.pathname;
//         var index1 = url.indexOf(pathname);
//         var index2 = url.indexOf("/", index1 + 1);
//         var baseLocalUrl = url.substr(0, index2);

//         return baseLocalUrl + "/";
//     }
//     else {
//         // Root Url for domain name
//         return baseURL + "/";
//     }
// }

// TODO: MOVE THIS LOGIC TO THE ACTIONS FOLDER
export const idleStatusDelay = idleStatus => (dispatch, getState) => {
    // NOTE: SETTING THE RETURN VALUE TOO HIGH WILL CAUSE UNEXPECTED RESULTS AS IT WILL INTERPRET VERY HIGH NUMBERS AS ZERO
    if (idleStatus === IDLESTATUS_AWAY) return 60000; // User becomes away after 60 seconds inactivity.
    if (idleStatus === IDLESTATUS_INACTIVE) return 420000; // Set as the users inactive delay time to 7 minutes.
    if (idleStatus === IDLESTATUS_EXPIRED && process.env.REACT_APP_ENV === 'production') {
        return 120000 // Set the user logout delay time to 2 minutes from inactive time.
    } else if (idleStatus === IDLESTATUS_EXPIRED && (process.env.REACT_APP_ENV === 'staging' || process.env.REACT_APP_ENV === 'testing')) {
        return 9999999; // Increase logout time for development only
    }
}

export const activeStatusAction = (dispatch, getState) => {
    // LET THE REST OF THE APP KNOW THE USER IS ACTIVE/AVAILABLE
    dispatch({
        type: types.GET_USER_ACTIVITY_STATUS_SUCCESS,
        payload: 'active'
    });

    // SEND CALL TO FIREBASE DB TO POSSIBLY LET OTHER USERS KNOW THIS PERSON IS "ACTIVE/AVAILABLE" (PROPOSED FEATURE)
    db.ref(`clients/${firebase.auth().currentUser.uid}/activityStatus`).set('active', logFirebaseError);
}

export const idleStatusAction = idleStatus => (dispatch, getState) => {
    // if (idleStatus === IDLESTATUS_ACTIVE) {
    //     console.log('IDLE STATUS: User is now active.')
    // }
    if (idleStatus === IDLESTATUS_AWAY) {
        console.info('IDLE STATUS: User is away.')

        // LET THE REST OF THE APP KNOW THE USER IS AWAY
        dispatch({
            type: types.GET_USER_ACTIVITY_STATUS_SUCCESS,
            payload: 'away'
        });

        // SEND CALL TO FIREBASE DB TO LET OTHER USERS KNOW THIS PERSON IS "AWAY"
        db.ref(`clients/${firebase.auth().currentUser.uid}/activityStatus`).set('away', logFirebaseError);
    }
    if (idleStatus === IDLESTATUS_INACTIVE) {
        // AFTER 7 MORE MINUTES SHOW A DIALOG WINDOW THAT PROMPTS THE USER TO TAKE ACTION OF THEY WILL BE LOGGED OUT IN 2 MORE MINUTES
        console.log('IDLE STATUS: User is inactive.');

        // LET THE REST OF THE APP KNOW THE USER IS INACTIVE
        dispatch({
            type: types.GET_USER_ACTIVITY_STATUS_SUCCESS,
            payload: 'inactive'
        });
        // alert('INACTIVE. SHOULD NOT LOGOUT');
        // SEND CALL TO FIREBASE DB TO POSSIBLY LET OTHER USERS KNOW THIS PERSON IS "INACTIVE" (PROPOSED FEATURE)
        db.ref(`clients/${firebase.auth().currentUser.uid}/activityStatus`).set('inactive', logFirebaseError);

    }
    if (idleStatus === IDLESTATUS_EXPIRED) {
        console.log('LOGGING OUT');

        // LET THE REST OF THE APP KNOW THE USER IS IN LOGGED OUT IDLE STATUS
        dispatch({
            type: types.GET_USER_ACTIVITY_STATUS_SUCCESS,
            payload: 'logged-out'
        });
        // alert('LOGGING OUT');

        // SEND CALL TO FIREBASE DB TO POSSIBLY LET OTHER USERS KNOW THIS PERSON IS "LOGGED OUT" (PROPOSED FEATURE)
        db.ref(`clients/${firebase.auth().currentUser.uid}/activityStatus`).set('logged-out', logFirebaseError);

        // INITIATE LOGOUT
        dispatch(() => getClientData(null));
        dispatch(() => clearUserData());
        firebase.auth().signOut()
            .then(() => {
                // console.log('USER IS SIGNED OUT OF FIREBASE');
                dispatch({
                    type: types.LOG_OUT_SUCCESS
                });
                window.location.reload(true); // reloads the window to force new token to be used insread of cached token - essentially erasing all previous client data
            })
            .catch(e => {
                console.log(e)
            });
    }
}

// These are the default events that will trigger user active status but can be customized if provided.
const activeEvents = ['mousemove', 'keydown', 'wheel', 'DOMMouseScroll', 'mouseWheel', 'mousedown', 'touchstart', 'touchmove', 'MSPointerDown', 'MSPointerMove'];

const opts = {
    appName: 'cyno',
    IDLE_STATUSES,
    idleStatusDelay,
    activeStatusAction,
    idleStatusAction,
    activeEvents,
};

const {
    middleware,
    reducer,
    actions
} = configure(opts);
export {
    middleware,
    reducer,
    actions
};


// WEBPACK FOOTER //
// ./src/js/utils/reduxIdleMonitor.js